export default __webpack_public_path__ + "static/media/GelatoX2.24b4ea3a.jpg";